import {createContext, Dispatch, SetStateAction} from 'react';

export interface ICommonLayoutContext {
    setUpButtonClassName?: Dispatch<SetStateAction<string | undefined>>;
    upButtonClassName?: string;
}

export const CommonLayoutContext = createContext<ICommonLayoutContext>({});
